/* Variant selection + gallery thumbnail switching for the product page. */
(function productForm() {
  const section = document.querySelector('[data-product-section]');
  if (!section) return;

  const jsonEl = section.querySelector('[data-product-json]');
  if (!jsonEl) return;

  let product;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch (error) {
    return;
  }

  const optionSelects = Array.from(section.querySelectorAll('[data-product-option]'));
  const variantIdInput = section.querySelector('[data-product-variant-id]');
  const priceWrapper = section.querySelector('[data-product-price]');
  const addToCartButton = section.querySelector('[data-add-to-cart]');
  const addToCartText = section.querySelector('[data-add-to-cart-text]');
  const mainImage = section.querySelector('[data-product-main-image]');
  const thumbs = Array.from(section.querySelectorAll('[data-product-thumb]'));

  function moneyFormat(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
  }

  function findVariant(selectedOptions) {
    return product.variants.find((variant) =>
      variant.options.every((value, index) => value === selectedOptions[index])
    );
  }

  function updateForVariant(variant) {
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceWrapper) {
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceWrapper.innerHTML = onSale
        ? `<div class="price price--on-sale"><s class="price__compare">${moneyFormat(variant.compare_at_price)}</s> <span class="price__sale">${moneyFormat(variant.price)}</span></div>`
        : `<div class="price"><span class="price__regular">${moneyFormat(variant.price)}</span></div>`;
    }

    if (addToCartButton) {
      addToCartButton.disabled = !variant.available;
      if (addToCartText) {
        addToCartText.textContent = variant.available
          ? addToCartText.dataset.available || addToCartText.textContent
          : addToCartText.dataset.unavailable || addToCartText.textContent;
      }
    }

    if (mainImage && variant.featured_image) {
      mainImage.src = variant.featured_image.src;
      mainImage.alt = variant.featured_image.alt || '';
    }
  }

  if (optionSelects.length) {
    optionSelects.forEach((select) => {
      select.addEventListener('change', () => {
        const selectedOptions = optionSelects
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((el) => el.value);
        const variant = findVariant(selectedOptions);
        if (variant) updateForVariant(variant);
      });
    });
  }

  if (thumbs.length && mainImage) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const img = thumb.querySelector('img');
        if (!img) return;
        mainImage.src = img.src.replace(/width=\d+/, 'width=1200');
        mainImage.alt = img.alt;
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }
})();
